module.exports = __webpack_public_path__ + "static/fpk-1c1dc4246d9bf93208879178741d70d7.png";